export const DEFAULT_THEME = {
    mode: 'light',
    backgroundContrast: 'normal',
    sidebarMode: 'apparent',
    fontFamily: 'system',
    fontSize: 'medium',
    spacingMode: 'normal',
    layoutDensity: 'standard',
    colorPreset: 'blue',
};
export const COLOR_PRESETS = {
    blue: {
        primary: {
            50: '#eff6ff',
            100: '#dbeafe',
            200: '#bfdbfe',
            300: '#93c5fd',
            400: '#60a5fa',
            500: '#3b82f6',
            600: '#2563eb',
            700: '#1d4ed8',
            800: '#1e40af',
            900: '#1e3a8a',
        },
        secondary: {
            50: '#f0f9ff',
            100: '#e0f2fe',
            200: '#bae6fd',
            300: '#7dd3fc',
            400: '#38bdf8',
            500: '#0ea5e9',
            600: '#0284c7',
            700: '#0369a1',
            800: '#075985',
            900: '#0c4a6e',
        },
        tertiary: {
            50: '#f8fafc',
            100: '#f1f5f9',
            200: '#e2e8f0',
            300: '#cbd5e1',
            400: '#94a3b8',
            500: '#64748b',
            600: '#475569',
            700: '#334155',
            800: '#1e293b',
            900: '#0f172a',
        },
    },
    green: {
        primary: {
            50: '#f0fdf4',
            100: '#dcfce7',
            200: '#bbf7d0',
            300: '#86efac',
            400: '#4ade80',
            500: '#22c55e',
            600: '#16a34a',
            700: '#15803d',
            800: '#166534',
            900: '#14532d',
        },
        secondary: {
            50: '#ecfdf5',
            100: '#d1fae5',
            200: '#a7f3d0',
            300: '#6ee7b7',
            400: '#34d399',
            500: '#10b981',
            600: '#059669',
            700: '#047857',
            800: '#065f46',
            900: '#064e3b',
        },
        tertiary: {
            50: '#f9fafb',
            100: '#f3f4f6',
            200: '#e5e7eb',
            300: '#d1d5db',
            400: '#9ca3af',
            500: '#6b7280',
            600: '#4b5563',
            700: '#374151',
            800: '#1f2937',
            900: '#111827',
        },
    },
    purple: {
        primary: {
            50: '#faf5ff',
            100: '#f3e8ff',
            200: '#e9d5ff',
            300: '#d8b4fe',
            400: '#c084fc',
            500: '#a855f7',
            600: '#9333ea',
            700: '#7c3aed',
            800: '#6b21a8',
            900: '#581c87',
        },
        secondary: {
            50: '#f5f3ff',
            100: '#ede9fe',
            200: '#ddd6fe',
            300: '#c4b5fd',
            400: '#a78bfa',
            500: '#8b5cf6',
            600: '#7c3aed',
            700: '#6d28d9',
            800: '#5b21b6',
            900: '#4c1d95',
        },
        tertiary: {
            50: '#f8fafc',
            100: '#f1f5f9',
            200: '#e2e8f0',
            300: '#cbd5e1',
            400: '#94a3b8',
            500: '#64748b',
            600: '#475569',
            700: '#334155',
            800: '#1e293b',
            900: '#0f172a',
        },
    },
    orange: {
        primary: {
            50: '#fff7ed',
            100: '#ffedd5',
            200: '#fed7aa',
            300: '#fdba74',
            400: '#fb923c',
            500: '#f97316',
            600: '#ea580c',
            700: '#c2410c',
            800: '#9a3412',
            900: '#7c2d12',
        },
        secondary: {
            50: '#fffbeb',
            100: '#fef3c7',
            200: '#fde68a',
            300: '#fcd34d',
            400: '#fbbf24',
            500: '#f59e0b',
            600: '#d97706',
            700: '#b45309',
            800: '#92400e',
            900: '#78350f',
        },
        tertiary: {
            50: '#fafaf9',
            100: '#f5f5f4',
            200: '#e7e5e4',
            300: '#d6d3d1',
            400: '#a8a29e',
            500: '#78716c',
            600: '#57534e',
            700: '#44403c',
            800: '#292524',
            900: '#1c1917',
        },
    },
    red: {
        primary: {
            50: '#fef2f2',
            100: '#fee2e2',
            200: '#fecaca',
            300: '#fca5a5',
            400: '#f87171',
            500: '#ef4444',
            600: '#dc2626',
            700: '#b91c1c',
            800: '#991b1b',
            900: '#7f1d1d',
        },
        secondary: {
            50: '#fff5f5',
            100: '#fed7d7',
            200: '#feb2b2',
            300: '#fc8181',
            400: '#f56565',
            500: '#e53e3e',
            600: '#c53030',
            700: '#9b2c2c',
            800: '#822727',
            900: '#63171b',
        },
        tertiary: {
            50: '#f9fafb',
            100: '#f3f4f6',
            200: '#e5e7eb',
            300: '#d1d5db',
            400: '#9ca3af',
            500: '#6b7280',
            600: '#4b5563',
            700: '#374151',
            800: '#1f2937',
            900: '#111827',
        },
    },
    silverSand: {
        primary: {
            50: '#fafafa',
            100: '#f5f5f5',
            200: '#eeeeee',
            300: '#e0e0e0',
            400: '#d1cfcf',
            500: '#b8b6b6',
            600: '#a5a3a3',
            700: '#8e8c8c',
            800: '#757373',
            900: '#5c5a5a',
        },
        secondary: {
            50: '#f8f9fa',
            100: '#f1f3f4',
            200: '#e8eaed',
            300: '#dadce0',
            400: '#bdc1c6',
            500: '#9aa0a6',
            600: '#80868b',
            700: '#5f6368',
            800: '#3c4043',
            900: '#202124',
        },
        tertiary: {
            50: '#fafafa',
            100: '#f5f5f5',
            200: '#eeeeee',
            300: '#e0e0e0',
            400: '#bdbdbd',
            500: '#9e9e9e',
            600: '#757575',
            700: '#616161',
            800: '#424242',
            900: '#212121',
        },
    },
    sandalWood: {
        primary: {
            50: '#faf9f7',
            100: '#f4f1ed',
            200: '#e8e1d4',
            300: '#dccfbb',
            400: '#c9b99a',
            500: '#b5a082',
            600: '#a08768',
            700: '#886e53',
            800: '#6f5843',
            900: '#5a4635',
        },
        secondary: {
            50: '#f9f8f6',
            100: '#f2efea',
            200: '#e6ddd1',
            300: '#d6c7b5',
            400: '#c2ad95',
            500: '#ab9177',
            600: '#94745d',
            700: '#7a5e4a',
            800: '#644c3c',
            900: '#533e31',
        },
        tertiary: {
            50: '#f8f7f5',
            100: '#f0edea',
            200: '#e3ddd5',
            300: '#d4cbc0',
            400: '#bfb2a3',
            500: '#a69687',
            600: '#8d796c',
            700: '#3d342c',
            800: '#2a231e',
            900: '#1a1510',
        },
    },
};
export const FONT_FAMILIES = {
    system: {
        name: 'System Default',
        cssClass: 'font-system',
    },
    sans: {
        name: 'Inter',
        cssClass: 'font-sans',
        googleFont: 'Inter:wght@100;200;300;400;500;600;700;800;900',
    },
    serif: {
        name: 'Crimson Text',
        cssClass: 'font-serif',
        googleFont: 'Crimson+Text:wght@400;600;700',
    },
    mono: {
        name: 'JetBrains Mono',
        cssClass: 'font-mono',
        googleFont: 'JetBrains+Mono:wght@100;200;300;400;500;600;700;800',
    },
};
export const FONT_SIZES = {
    small: { name: 'Small', scale: '0.875' },
    medium: { name: 'Medium', scale: '1' },
    large: { name: 'Large', scale: '1.125' },
    'extra-large': { name: 'Extra Large', scale: '1.25' },
};
export const SPACING_MODES = {
    compact: {
        name: 'Compact',
        scale: '0.75',
        description: 'Dense spacing for maximum content visibility'
    },
    normal: {
        name: 'Normal',
        scale: '1',
        description: 'Balanced spacing for general use'
    },
    spacious: {
        name: 'Spacious',
        scale: '1.5',
        description: 'Generous spacing for better readability'
    },
};
export const LAYOUT_DENSITIES = {
    compact: {
        name: 'Compact',
        description: 'Smaller form fields, reduced modal padding, tighter tables'
    },
    standard: {
        name: 'Standard',
        description: 'Default layout with comfortable spacing and sizing'
    },
};
export const BACKGROUND_PALETTES = {
    minimal: {
        name: 'Minimal',
        light: { primary: '#fafafa', secondary: '#f5f5f5', accent: '#e5e5e5' },
        dark: { primary: '#0a0a0a', secondary: '#171717', accent: '#262626' }
    },
    warm: {
        name: 'Warm',
        light: { primary: '#fef7ed', secondary: '#fed7aa', accent: '#fdba74' },
        dark: { primary: '#7c2d12', secondary: '#9a3412', accent: '#c2410c' }
    },
    cool: {
        name: 'Cool',
        light: { primary: '#f0f9ff', secondary: '#e0f2fe', accent: '#bae6fd' },
        dark: { primary: '#0c4a6e', secondary: '#075985', accent: '#0369a1' }
    },
    nature: {
        name: 'Nature',
        light: { primary: '#f0fdf4', secondary: '#dcfce7', accent: '#bbf7d0' },
        dark: { primary: '#14532d', secondary: '#166534', accent: '#15803d' }
    },
    sunset: {
        name: 'Sunset',
        light: { primary: '#fff7ed', secondary: '#fed7aa', accent: '#fb923c' },
        dark: { primary: '#7c2d12', secondary: '#9a3412', accent: '#ea580c' }
    },
    ocean: {
        name: 'Ocean',
        light: { primary: '#f0fdfa', secondary: '#ccfbf1', accent: '#99f6e4' },
        dark: { primary: '#042f2e', secondary: '#134e4a', accent: '#047857' }
    }
};
